import styled from 'styled-components'

export const TodoContainer = styled.div`
  &.no_content {
    margin-bottom: 50px;
  }
`
